import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material"
import { StyledButton } from "components/Button/StyledButton"

type DeleteDialogProps = {
  open: boolean
  onClose: () => void
  onDelete: () => void
}

export const DeleteDialog = (props: DeleteDialogProps) => {
  const { open, onClose, onDelete } = props

  return (
    <Dialog open={open}>
      <DialogTitle>Löschen</DialogTitle>
      <DialogContent sx={{ overflowY: "visible" }}>
        <Typography>Möchten Sie diese Daten wirklich löschen?</Typography>
      </DialogContent>
      <DialogActions>
        <StyledButton buttonType="cancel" onClick={onClose} variant="contained">
          Abbrechen
        </StyledButton>
        <StyledButton buttonType="custom" onClick={onDelete} variant="contained">
          Löschen
        </StyledButton>
      </DialogActions>
    </Dialog>
  )
}
